export default class CommonRuleConstants {
    static readonly MaxLives: number = 3;
    static readonly DistanceToGenerateStopper: number = 2200;
    static readonly DistanceToGenerateOutfit: number = 2200;
    static readonly DistanceToGenerateBonus: number = 3600;
}